import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./i18n";
import routes from "./routes";
import { useEffect } from "react";
import { zoomState } from "state";
import { useSetRecoilState } from "recoil";

function App() {
  const setZoom = useSetRecoilState(zoomState);
  useEffect(() => {
    if (window && window.innerHeight < 640) {
      setZoom(window.innerHeight / 640);
    }
  }, []);

  return (
    <Router>
      <Routes>
        {routes.map((route) => (
          <Route {...route} />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
